import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TriptyqueStickers } from '@components/triptyque-stickers/models';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-triptyque-stickers',
  templateUrl: './triptyque-stickers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent],
})
export class TriptyqueStickersComponent extends AbstractDynamicComponent<TriptyqueStickers> {}
